export enum FacilityDetailsModeEnum {
  validate,
  edit,
  add
}